import React from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { DEFAULT_PROJECT_NAMES } from "../../constants/general";
import { generateNewIdAndNavigate } from "../../thunks/dashboardThunks";
import { setIsFacelessVideo } from "../../store/project/projectSlice";
import { openCansvasSizeModal } from "../../store/common/profileModalSlice";

const Banner = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleNewTemplate = () => {
    console.log("fun called");
    // dispatch(setIsFacelessVideo(!!props.isFaceless));
    dispatch(openCansvasSizeModal());
    //   return;
    // }
    // dispatch(
    //   generateNewIdAndNavigate(
    //     navigate,
    //     "/editor/user-template/",
    //     DEFAULT_PROJECT_NAMES["user-template"]
    //   )
    // );
  };

  return (
    <div className="flex p-6 rounded-xl border border-solid border-gray-300 bg-gradient-template">
      <div className="ml-6 flex-1">
        <div className="flex p-6">
          <div className="flex-shrink-0 px-10 space-x-[-30%] space-y-[-30%]">
            <img
              src="/tool/dashboard/static/images/sample-template-1.png"
              alt="Sample Poster 1"
              className="w-32 rounded-md shadow-lg"
            />
            <img
              src="/tool/dashboard/static/images/sample-template-2.png"
              alt="Sample Poster 2"
              className="w-32 rounded-md shadow-lg"
            />
          </div>
          <div className="ml-6 flex-1">
            <h2 className="text-xl font-bold mb-2">
              Foster creativity by crafting your unique video template.
            </h2>
            <p className="text-gray-700 mb-4">
              Optimize video production efficiency through tailored template
              customization
            </p>
            <button
              onClick={handleNewTemplate}
              className="bg-blue-500 text-white rounded px-4 py-2 hover:bg-blue-600"
            >
              Create your first video
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Banner;
